import { render } from "./PaymentRegister.vue?vue&type=template&id=6d90b204&scoped=true&ts=true"
import script from "./PaymentRegister.vue?vue&type=script&lang=ts"
export * from "./PaymentRegister.vue?vue&type=script&lang=ts"

import "./PaymentRegister.vue?vue&type=style&index=0&id=6d90b204&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d90b204"]])

export default __exports__